var exports = {
  "AW": "ColumnHeader__uC8Tiq",
  "SX": "Name__eLWC6I",
  "Jc": "LeadingVisual__ZMOJUt",
  "y_": "Count__41jS66",
  "LN": "Trailing__O-lpqe",
};

module.exports = exports;
